import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import AppTabs from '../../components/designe/app-tabs/AppTabs';
import PageContainer from '../../components/layout/page-container/PageContainer';
import UsersList from '../../components/reusable/users-list/UsersList';
import {
  useGetMyDetails,
  useLazyGetRejectedUserSubscriberRequests,
  useLazyGetUserSubscriberRequests,
  useLazyGetUserSubscribers,
  useLazyGetUserSubscriptions,
} from '../../services/redux/api/usersApi';
import { Paths } from '../../shared/paths';
import { useStyles } from './People.styles';
import theme from '../../styles/theme';
import { orderBy } from '../../utils/array-utils';
import AllUsers from './all-users/AllUsers';

export default function People(props) {
  const { t } = useTranslation();
  const { data: user } = useGetMyDetails();
  const [getUserSubscribers, { data: userSubscribers }] =
    useLazyGetUserSubscribers();
  const [getUserSubscriptions, { data: userSubscriptions }] =
    useLazyGetUserSubscriptions();
  const [getUserSubscriberRequests, { data: userSubscriberRequests }] =
    useLazyGetUserSubscriberRequests();
  const [
    getRejectedUserSubscriberRequests,
    { data: rejectedUserSubscriberRequests },
  ] = useLazyGetRejectedUserSubscriberRequests();
  const { classes } = useStyles(theme);

  const tabsConfig = [
    { label: t('people.allUsers'), path: `${Paths.people.root}` },
    {
      label: t('people.subscriptions'),
      path: `${Paths.people.root}${Paths.people.subscriptions}`,
    },
    {
      label: t('people.subscribers'),
      path: `${Paths.people.root}${Paths.people.subscribers}`,
    },
    {
      label: t('people.requests'),
      path: `${Paths.people.root}${Paths.people.requests}`,
    },
  ];

  useEffect(() => {
    if (user) {
      getUserSubscribers(user.id);
      getUserSubscriptions(user.id);
      getUserSubscriberRequests(user.id);
      getRejectedUserSubscriberRequests(user.id);
    }
  }, [user?.id]);

  function getRequests() {
    return orderBy(
      [
        ...(userSubscriberRequests || []),
        ...(rejectedUserSubscriberRequests || []),
      ],
      ['firstname', 'lastname'],
      ['asc', 'asc'],
    );
  }

  return (
    <PageContainer title={t('common.people')}>
      <div className={classes.usersWrapper}>
        <AppTabs config={tabsConfig} />
        <div className={classes.tabsContent}>
          <Routes>
            <Route path={'/'} element={<AllUsers />} />
            <Route
              path={Paths.people.subscriptions}
              element={<UsersList users={userSubscriptions} showSearch />}
            />
            <Route
              path={Paths.people.subscribers}
              element={
                <UsersList
                  users={userSubscribers}
                  showStatusButton
                  showSearch
                />
              }
            />
            <Route
              path={Paths.people.requests}
              element={
                <UsersList users={getRequests()} showStatusButton showSearch />
              }
            />
          </Routes>
        </div>
      </div>
    </PageContainer>
  );
}
